import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, X } from "lucide-react";
import { Button } from "../components/ui/button";

const COOKIE_CONSENT_KEY = "kbr_cookie_consent";

const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      // Small delay so it doesn't flash immediately
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ essential: true, analytics: true, date: new Date().toISOString() }));
    setIsVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({ essential: true, analytics: false, date: new Date().toISOString() }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] animate-fade-in-up"
      data-testid="cookie-consent-banner"
    >
      <div className="bg-[#0F172A] border-t-2 border-[#C2410C] shadow-2xl">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4 md:py-5">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            {/* Icon + Text */}
            <div className="flex items-start gap-3 flex-1">
              <ShieldCheck className="w-6 h-6 text-[#C2410C] flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-white text-sm leading-relaxed">
                  Ce site utilise des cookies pour améliorer votre expérience de navigation et mesurer l'audience. 
                  Les cookies essentiels sont nécessaires au fonctionnement du site.{" "}
                  <Link
                    to="/politique-de-confidentialite"
                    className="text-[#C2410C] hover:underline font-medium"
                  >
                    En savoir plus
                  </Link>
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0 w-full md:w-auto">
              <Button
                onClick={handleRefuse}
                variant="outline"
                className="flex-1 md:flex-none h-10 px-5 text-xs uppercase font-bold tracking-wider text-white/80 border-white/20 hover:bg-white/10 hover:text-white rounded-none"
                data-testid="cookie-refuse-btn"
              >
                Refuser
              </Button>
              <Button
                onClick={handleAcceptAll}
                className="flex-1 md:flex-none h-10 px-5 text-xs uppercase font-bold tracking-wider bg-[#C2410C] hover:bg-[#9A3412] text-white rounded-none"
                data-testid="cookie-accept-btn"
              >
                Tout accepter
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
